import { render, staticRenderFns } from "./ProductCarouselV2.vue?vue&type=template&id=6c01703e"
import script from "./ProductCarouselV2.vue?vue&type=script&lang=js"
export * from "./ProductCarouselV2.vue?vue&type=script&lang=js"
import style0 from "./ProductCarouselV2.vue?vue&type=style&index=0&id=6c01703e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports